import { useModal } from "@/app/shared/modal-views/use-modal";
import cn from "@/utils/class-names";
import { canAccess } from "@/utils/Utils";
import { PiPlusBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { Button, type ButtonProps } from "rizzui";

interface ModalButtonProps extends ButtonProps {
    label?: string;
    className?: string;
    customSize?: string;
    role?: any;
    permission?: any;
    icon?: React.ReactNode;
    view?: React.ReactNode;
    path?: string;
}

export default function ModalButton({
    label = "Add New",
    className,
    customSize = "500px",
    view,
    icon = <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />,
    role,
    permission,

    ...rest
}: ModalButtonProps) {
    const { openModal } = useModal();
    const navigate = useNavigate();

    const handleClick = () => {
        if (rest.path && rest.path !== "") {
            navigate(rest.path);
            return;
        }

        openModal({ view, customSize, });
    };

    return (
        canAccess({ role: role, permission: permission }) && (
            <Button
                className={cn(
                    "mt-5 w-full text-xs capitalize @lg:w-auto sm:text-sm lg:mt-0",
                    className,
                )}
                onClick={handleClick}
                {...rest}
            >
                {icon}
                {label}
            </Button>
        )
    );
}
